// src/config/amapConfig.js
module.exports = {
  // ★★★ 请在此处填入你申请的高德 Key ★★★
  securityJsCode: '5bc66c624a16b049025e6eccf2a84977', 
  key: '48eeecfb524aa77cec1461f5c23fadd7',          
  
  // 地图默认中心点 (上海国家会展中心)
  center: [121.301464, 31.189896],
  zoom: 13
};